import React from 'react';
export function Footer() {
  return <footer className="bg-forest-dark text-sand py-12 border-t border-forest" data-id="element-127">
      <div className="container mx-auto px-4 text-center max-w-2xl" data-id="element-128">
        <h4 className="text-white font-bold text-xl mb-4" data-id="element-129">
          ⛏️ MEGAPACK MINERÍA LISTO™
        </h4>

        <p className="mb-6 text-sm leading-relaxed" data-id="element-130">
          Hecho por especialistas, para docentes de minería y técnicas mineras
          de toda Argentina.
          <br data-id="element-131" />
          <strong className="text-gold mt-2 block" data-id="element-132">
            🇦🇷⛏️ "La próxima clase que des, podés entrar al aula sabiendo que
            Argentina tiene la historia minera más rica de América del Sur."
          </strong>
        </p>

        <div className="flex flex-wrap justify-center gap-4 text-sm mb-8" data-id="element-133">
          <a href="mailto:packcentral23@gmail.com" className="hover:text-white transition-colors" data-id="element-134">
            📧 packcentral23@gmail.com
          </a>
          <span className="hidden sm:inline" data-id="element-135">·</span>
          <span className="hover:text-white transition-colors" data-id="element-136">
            📱 @centralpack.ar
          </span>
        </div>

        <div className="text-xs text-sand/50 border-t border-forest pt-8" data-id="element-137">
          <p className="mb-2" data-id="element-138">
            © MEGAPACK MINERÍA LISTO™ 2026 — Todos los derechos reservados.
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}